import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ALERT_TRANSPARENT_COLORS_MAP } from '../../../constants/alert-transparent.constants';
import { AlertTransparentColorType } from '../../../types/alert-transparent.type';

@Component({
  selector: 'fr8bot-ui-alert-transparent',
  templateUrl: './alert-transparent.component.html',
  styleUrl: './alert-transparent.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertTransparentUIComponent {
  readonly color = input<AlertTransparentColorType>('orange');

  readonly COLORS_MAP = ALERT_TRANSPARENT_COLORS_MAP;
}
